/** Naming spec for Inbox Pulse: a heartbeat line running through an
 * envelope outline, Orion blue, with an optional amber dot for unread
 * captures. Inlined rather than a shared components/icons/ folder — this
 * codebase keeps icons next to their one or two call sites (see
 * MobileNav.tsx, AuditLogPage.tsx) rather than a generic icon library. */
export function PulseIcon({ size = 20, unread = false }: { size?: number; unread?: boolean }) {
  return (
    <span className="relative inline-flex shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#2E47D6" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
        <path d="m2.5 6.5 9.5 7 9.5-7" />
        <path d="M3.5 17.5h4l1.3-2.6 2 4.2 1.6-3.4 1.1 1.8h6.5" />
      </svg>
      {unread && <span className="absolute -right-0.5 -top-0.5 size-2 rounded-full border border-white" style={{ background: '#F2B25C' }} aria-hidden="true" />}
    </span>
  );
}
